import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const notificationsWeb: PluginWebManifest = {
  // notifications uses raw `routes` + `navItems` (the nav lives in
  // the user-menu group, not the main sidebar) instead of
  // `definePage`, so the overview card is written by hand. `to`
  // points at the user-facing inbox page, which is where the
  // "Notifications" card on the plugins overview surface should
  // land users.
  overviewCards: [
    {
      to: '/notifications',
      label: 'Notifications',
      icon: 'Bell',
      description: 'Per-user inbox for product and operational updates.',
      details:
        'Delivers typed notifications — release announcements, plugin-disabled warnings, hand-authored markdown updates — to a per-user inbox. A live websocket subscription updates the user-menu badge as new notifications arrive so users never have to refresh to see them.',
      features: [
        '"Notifications" entry in the user menu with an unread badge',
        'Per-user inbox at /notifications with detail drill-downs',
        'Typed renderers (release, plugin-disabled, markdown) for rich payloads',
        'Live websocket subscription — no polling',
        'Dismissable rows with persisted state per user',
      ],
      group: 'misc',
    },
  ],
  routes: [
    {
      path: '/notifications',
      componentPath: '@reflex/plugin-notifications/web/NotificationsListPage',
    },
    {
      path: '/notifications/:id',
      componentPath: '@reflex/plugin-notifications/web/NotificationDetailPage',
    },
  ],
  navItems: [
    {
      to: '/notifications',
      label: 'Notifications',
      icon: 'Bell',
      group: 'user-menu',
      badge: '@reflex/plugin-notifications/web/UserMenuNotificationsBadge',
      // First of the account rows: the unread badge is why people open the
      // menu at all.
      order: 10,
    },
  ],
  commands: [
    {
      to: '/notifications',
      label: 'Notifications',
      icon: 'Bell',
      group: 'settings',
    },
  ],
  globalUiElements: [
    {
      id: 'notifications-live-subscription',
      componentPath: '@reflex/plugin-notifications/web/NotificationsLiveSubscription',
    },
  ],
};
